import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';

import QButton from 'components/QButton';
import ProgressBar from 'components/ProgressBar';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.greyScale[7],
    width: '100%',
    maxHeight: '100%',
    height: 500,
    overflow: 'hidden',
    position: 'relative',
    borderRadius: 3,
  },
  contentSpace: {
    height: 'calc(100% - 52px)',
    width: 'calc(100% - 48px)',
    position: 'relative',
    margin: '32px 24px 24px',
  },
  bottomBar: {
    flexShrink: 0,
    height: 72,
    width: '100%',
    backgroundColor: theme.palette.greyScale[6],
    zIndex: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 24px 12px',
  },

  rootSpace: {
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 1,
    width: '100%',
    height: '100%',
    transition: 'top 1.2s, opacity 1s',
  },

  progressWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 4px',
  },
  progress: {
    opacity: 0.7,
    marginRight: 18,
    marginLeft: 6,
  },

  topGradient: {
    position: 'absolute',
    backgroundImage: `linear-gradient(${theme.palette.greyScale[7]}, ${theme.applyOpacityToHex(theme.palette.greyScale[7], 0)})`,
    top: 0,
    left: 0,
    width: '100%',
    height: 16,
  },
  bottomGradient: {
    zIndex: 1,
    position: 'absolute',
    backgroundImage: `linear-gradient(${theme.applyOpacityToHex(theme.palette.greyScale[7], 0)}, ${theme.palette.greyScale[6]})`,
    bottom: 72,
    left: 0,
    width: '100%',
    height: 16,
  },
  flex: {
    display: 'flex',
  },
});

const upPosition = -416;
const lowPosition = 416;

class FlowDialog extends PureComponent {

  render() {
    const { classes, flowState, renderList, goBack, goForward, disableBack, disableForward, dialogStyle } = this.props;

    return (
      <Dialog
        open
        fullWidth
        maxWidth="md"
        disableBackdropClick
        disableEscapeKeyDown
        disableEnforceFocus
        classes={{
          root: dialogStyle,
        }}
      >
        <div className={classes.root}>
          <div className={classes.contentSpace}>
            {renderList.map((renderFunc, index) => {
              const upState = flowState === index+1;
              const downState = flowState === index-1;
              if (index === 0) {
                return ((flowState < index+2) &&
                  <div
                    className={classes.rootSpace}
                    style={{
                      top: (upState && (upPosition)),
                      opacity: upState && 0,
                    }}
                    key={index} // eslint-disable-line react/no-array-index-key
                  >
                    {renderFunc(flowState === index)}
                  </div>
                );
              }
              if (index > 1) {
                return ((flowState < index+2) && (flowState > index-2) &&
                  <div
                    className={classes.rootSpace}
                    style={{
                      top: (upState && (upPosition)) || (downState && lowPosition),
                      opacity: (upState || downState) && 0,
                    }}
                    key={index} // eslint-disable-line react/no-array-index-key
                  >
                    {renderFunc(flowState === index)}
                  </div>
                );
              }
              return ((flowState < index+2) &&
                <div
                  className={classes.rootSpace}
                  style={{
                    top: (upState && upPosition) || (downState && lowPosition),
                    opacity: (upState || downState) && 0,
                  }}
                  key={index} // eslint-disable-line react/no-array-index-key
                >
                  {renderFunc(flowState === index)}
                </div>
              );
            })}
          </div>

          <div className={classes.topGradient}/>
          <div className={classes.bottomGradient}/>

          <div className={classes.bottomBar}>
            <ProgressBar
              width={360}
              size={renderList.length}
              index={flowState}
              style={{ marginLeft: 8 }}
            />
            <div className={classes.flex}>
              <QButton
                id="goBackBtn"
                disabled={disableBack}
                variant="outlined"
                onClick={goBack}
                width={96}
              >
                Back
              </QButton>
              <QButton
                id="goForwardBtn"
                disabled={disableForward}
                variant="contained"
                onClick={goForward}
                style={{ marginLeft: 12 }}
                width={96}
              >
                Next
              </QButton>
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}


FlowDialog.defaultProps = {
  disableBack: false,
  disableForward: false,
};

FlowDialog.propTypes = {
  classes: PropTypes.object,
  flowState: PropTypes.number,
  renderList: PropTypes.array,
  goBack: PropTypes.func,
  goForward: PropTypes.func,
  disableBack: PropTypes.bool,
  disableForward: PropTypes.bool,
  dialogStyle: PropTypes.string,
};


export default compose(
  withStyles(styles),
)(FlowDialog);
